import React from 'react'
import Contact from '../components/Contact/Contact'
import Footer from '../components/Footer/Footer'

const contact = () => {
  return (
    <div> 
     <Contact/>
     <Footer/>
     </div>
  )
}

export default contact